const todoPanelInitialState = {
    activeTodoId: "",
    isShowingEditPanel: false,
    isEditingTitle: false,
    isDeletingTodo: false,
    isShowingChooseDeadlineModal: false,
    isShowingCalendar: false,
};

export default todoPanelInitialState;

